import { SELECIONAR_EMISSAO_CTE_OS } from '../../actions/types'

const initialState = null
const estadoInicial = {
  id: null,
  tomador: {},
  serie: '',
  quantidadeCarga: null,
  veiculo: {},
  cidadeOrigem: {},
  cidadeDestino: {}
}

export default function reducerEmissaoCteOsSelecionado (state = estadoInicial, action = initialState) {
  switch (action.type) {
    case SELECIONAR_EMISSAO_CTE_OS: {
      if (action.payload == null) {
        return estadoInicial;
      }
      return action.payload;
    }

    default: {
      return state
    }
  }
}